App.namespace('components.visited_page_time_tracking', () => {
  // don't try to track anything if beacon is not supported
  if (!window.navigator.sendBeacon) {
    return;
  }

  const watch = App.components.stop_watch();

  const init = () => {
    watch.init();
    if (!App.components.page_visibility_api.isPageHidden()) {
      watch.start();
    }
  };

  const onBeforeUnload = () => {
    watch.stop();

    const { startTime, duration, currentTime } = watch.getTimes();

    App.track.custom(window.__DATA_TRACKING_VISIT_TIME_SPENT, {
      roomId: window.__DATA_TRACKING_VAR__ROOM_ID,
      tagSlug: window.__DATA_TRACKING_VAR__TAG_SLUG || null,
      timeVisited: startTime,
      timeExited: currentTime,
      duration,
    });
  };

  init();

  const onVisibilityChange = ({ visible }) => {
    if (visible) {
      watch.start();
    } else {
      watch.stop();
    }
  };

  App.components.page_visibility_api.init(onVisibilityChange);

  window.addEventListener('beforeunload', onBeforeUnload);

  return { watch };
});
